/**
 * Notifications carry English and Arabic text (`title`/`title_ar`,
 * `message`/`message_ar`). Show the one matching the UI language; a blank
 * Arabic twin (free-text notifications) falls back to the other field.
 */
import { Notification } from '../types/notification';

type Localizable = Pick<Notification, 'title' | 'message' | 'title_ar' | 'message_ar'>;
type Dir = 'ltr' | 'rtl' | 'auto';

export const notificationTitle = (n: Localizable, isRTL: boolean): string =>
  (isRTL && n.title_ar) || n.title;

export const notificationMessage = (n: Localizable, isRTL: boolean): string =>
  (isRTL && n.message_ar) || n.message;

/**
 * Base direction for a shown title/message. When the Arabic twin exists the
 * pair is known to be English + Arabic, so the direction is the UI's — even
 * when an English sentence opens with an Arabic name, where `auto` would guess
 * RTL and truncate from the wrong end. Without a twin the language is unknown
 * (free text, or an English-only legacy row), so let the browser detect it.
 */
export const notificationDir = (twin: string | undefined, isRTL: boolean): Dir =>
  twin ? (isRTL ? 'rtl' : 'ltr') : 'auto';
